import { useNavigate } from "react-router-dom";
import SubadminList from "../../features/manageSubAdmin/subAdminList";
import SubadminListTopbar from "../../features/manageSubAdmin/topbar";

const ManageSubadmin = () => {

  const navigate = useNavigate();

  return (
    <>
      <div className="main_title">
        <h1>Manage Sub-Admin</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Manage Sub-Admin
        </p>
      </div>
      
      <div className="cards">
        <SubadminListTopbar />
        <SubadminList />
      </div>
    </>
  );
};

export default ManageSubadmin;
